module.exports = __webpack_public_path__ + "static/media/fortoyningsbolter.c1c935c9.svg";